import React from 'react'

const ContactUs = () => {
  return (
    <h1>ContactUs Page</h1>
  )
}

export default ContactUs;
